import React, { useEffect, useRef } from 'react';

import Close from '../../../icons/contact-us/close.svg';

export interface IToast {
  id: string;
  content: IToastContent;
}

export interface IToastContent {
  title: string;
  description: string;
}

export interface Props {
  content: IToastContent;
  remove: () => void;
}

const Toast = ({ content: { title, description }, remove }: Props) => {
  const removeRef = useRef(remove);

  removeRef.current = remove;

  useEffect(() => {
    const duration = 3000;
    const timeoutId = setTimeout(() => removeRef.current(), duration);

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <div className="toast">
      <Close onClick={remove} className="toast-close" />
      <div className="toast-header">{title}</div>
      <div className="toast-body">{description}</div>
    </div>
  );
};

export default Toast;
